import { loader } from "./actions.tsx";
import ValidatePage from "./validate.tsx";

export default {
  path: "/link/:hash",
  loader,
  Component: ValidatePage,
};
